export const searchBidStrategy = [
  { value: 'MAX_CONVERSION', label: '转化次数', setTypeLabel: '设置目标每次转化费用' },
  { value: 'MAX_CONVERSION_VALUE', label: '转化价值', setTypeLabel: '设置目标 ROAS' },
];

/**
 * 检查关键字列表中的非法不可见字符和格式问题
 * @param {string[]} keywords - 关键字数组
 * @returns {object[]} - 返回包含错误信息的对象数组
 */
export function checkKeywords(keywords) {
  // 正则解释：
  // \u200b : 零宽空格 (Zero Width Space) - 导致您报错的核心原因
  // \u200c-\u200d : 零宽连字/非连字符
  // \ufeff : 字节顺序标记 (BOM)
  // \x00-\x1F : ASCII 控制字符 (如换行、回车、制表符等，不应出现在短语中间)
  // \x7F : 删除符
  const invalidPattern = /[\u200b\u200c\u200d\ufeff\x00-\x1F\x7F\u3001\u3002\uff01\uff0c]/g;
  const doubleSpacePattern = /  +/g; // 匹配两个或更多连续空格

  const report = [];

  keywords.forEach((kw, index) => {
    const reasons = [];
    let cleanedKw = kw;

    // 1. 检测非法字符
    if (invalidPattern.test(kw)) {
      const matches = kw.match(invalidPattern);
      const charReasons = matches.map((char) => {
        const hexCode = char.charCodeAt(0).toString(16).toUpperCase().padStart(4, '0');
        let name = '未知不可见符号';
        if (hexCode === '3001') name = '中文/日文顿号 (、)';
        if (hexCode === '3002') name = '句号 (。)';
        if (hexCode === '200B') name = '零宽空格 (Zero Width Space)';
        if (hexCode === 'FEFF') name = 'BOM 标记';
        return `${name} [\\u${hexCode}]`;
      });
      reasons.push(...new Set(charReasons));
      cleanedKw = cleanedKw.replace(invalidPattern, '');
    }

    // 2. 检测连续空格
    if (doubleSpacePattern.test(kw)) {
      reasons.push('包含连续空格');
      cleanedKw = cleanedKw.replace(doubleSpacePattern, ' ');
    }

    // 如果有任何问题，添加到报告中
    if (reasons.length > 0) {
      report.push({
        index: index,
        original: kw,
        reasons: reasons.join(', '),
        suggestion: cleanedKw,
      });
    }
  });

  return report;
}
